<template>
<div class="vliveExample">
    <div class="phone-model phone_model phone_model1">
        <div class="phone-model-container">
            <!--直播封面-->
            <div class="banner default_image">
                <img :src="liveInfoData.logoPic.furl" alt="">
            </div>
            <!--直播内容-->
            <div class="vlive-content">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.columnname" v-for="(item, index) in navListData" :key="index">
                        <div></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import VliveContentVliveImageText from 'views/cms/vlive/components/vliveContentComponents/vliveContentVliveImageText'
import VliveContentComment from 'views/cms/vlive/components/vliveContentComponents/vliveContentComment'
export default {
    name: 'vliveExample2',
    props: ['liveInfoData', 'navListData'],
    data() {
        return {
            activeName: ''
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        handleClick(tab, event) {
            $(event.target).css({color: this.vliveModel.contentthemecolor}).siblings().css({color: '#303133'})
            $('.vlive-content .el-tabs__active-bar').css({backgroundColor: this.vliveModel.contentthemecolor})
        },
        ...mapActions([
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                $('.vlive-content .el-tabs__item.is-active').css({color: this.vliveModel.contentthemecolor})
                $('.vlive-content .el-tabs__active-bar').css({backgroundColor: this.vliveModel.contentthemecolor})
                if (this.vliveModel.contentList.length > 0) {
                    this.activeName = this.vliveModel.contentList[0].columntype.toString()
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {
        VliveContentVliveImageText,
        VliveContentComment
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveExample {
    overflow: hidden;
    .phone-model{
        position: relative;
        .phone-model-container{
            // height: 520px;
            height: 426px;
            // overflow-y: scroll;
            overflow-y: hidden;
            overflow-x: hidden;
        }
        .banner{
            // width: 318px;
            // height: 179px;
            width: 266px;
            height: 146px;
            .el-carousel__container{
                // width: 318px;
                // height: 179px;
                width: 266px;
                height: 146px;
                overflow: hidden;
            }
            img{
                width: 100%;
                height: 100%;
            }
            .el-carousel__button{
                width: 20px;
            }
        }
        .vlive-adv{
            width: 318px;
            height: 40px;
            .el-carousel__container{
                width: 318px;
                height: 40px;
                overflow: hidden;
            }
            img{
                width: 100%;
                height: 100%;
            }
            .el-carousel__indicators{
               display: none;
            }
        }
        .vlive-follow{
            padding: 10px 0;
            font-size: $font-14;
            @include flexBox(space-between);
            .left{
                @include flexBox(flex-start);
                color: $tcolor-gray;
                img{
                    width: 24px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
            .btn{
                box-sizing: border-box;
                padding: 5px 10px;
                border: 1px solid $tcolor-blue;
                border-radius: 11px;
                color: $tcolor-blue;
            }
        }
    }
    .phone_model1 {
        width: 340px!important;
        padding: 119px 42px 0 39px!important;
        .phone-model-container{
            width: 266px;
        }
        .el-tabs__item {
            padding: 0 12PX!important;
        }
    }
    .vlive-sign-up{
        position: absolute;
        bottom: 130px;
        right: 50px;
        img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }
    .image-list{
        @include flexBox(space-between);
        flex-wrap: wrap;
        img{
            margin-bottom: 10px;
            width: 45%;
            height: 100px;
        }
    }
    .video-list{
        .video{
            @include flexBox(flex-start);
            margin-bottom: 10px;
            img{
                width: 120px;
                height: 120px;
                flex-grow: 0;
            }
            .title{
                align-self: flex-start;
            }
        }
    }
}
</style>
